import React from "react";
import "./Css/Navigation.css";
import logo from "./Assets/Ben-10-logo.png";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  return (
    //Navbar
    <div className="navbar">
      <div className="container flex">
        <img src={logo} className="logo" alt="ben10" />
        <nav>
          <ul>
            <li className={splitLocation[1] === "docs" ? "active" : ""}>
              <Link to="/docs">Docs</Link>
            </li>
            <li>
              <a href="https://github.com/SaurabhSonde">Github</a>
            </li>
            <li className={splitLocation[1] === "buymeacoffee" ? "active" : ""}>
              <Link to="/buymeacoffee">Coffee</Link>
            </li>
            <li className={splitLocation[1] === "connect" ? "active" : ""}>
              <Link to="/connect">Connect</Link>
            </li>
            <li className={splitLocation[1] === "credits" ? "active" : ""}>
              <Link to="/credits">Credits</Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default Navigation;
